<div ng2FileDrop
     [ngClass]="{ 'file-drop-over': hasDropZoneOver, 'disabled': disabled }"
     [uploader]="uploader"
     (fileOver)="fileOver($event)"
     (onFileDrop)="fileDropped($event)"
     class="file-drop-zone">
    <div class="file-drop-zone-icon-container">
        <img class="icon-upload" [src]="'/assets/upload.png'">
    </div>
    <div class="file-drop-zone-body">
        <div class="file-drop-zone-select-btn">
            <input #fileInput type="file" id="file-drop-zone-select-input" class="file-drop-zone-select-input" [multiple]="multiple"
                   (change)="fileSelected($event)">
            <label class="btn btn-primary" for="file-drop-zone-select-input"
                   [ngClass]="{ 'disabled': disabled }" [i18n]="[{target: 'innerHTML', key: 'file-drop.buttons.select-file'}]"></label>
        </div>
        <span [i18n]="[{target: 'innerHTML', key: 'file-drop.drag-here'}]"></span>
    </div>
    <div class="file-drop-zone-files" *ngIf="files && files.length > 0">
        <div *ngFor="let file of files" class="file-drop-zone-file">
            <div>{{file.name}}</div>
            <div>
                <i class="fa fa-trash-alt" (click)="removeFile(file)"></i>
            </div>
        </div>
    </div>
</div>
